import { useEffect } from 'react';

/**
 * Mounts a single global IntersectionObserver that toggles the
 * `.is-visible` class on every `.btt-kicker` element as it scrolls
 * into the viewport — enabling the 2px green underline reveal.
 *
 * Idempotent: safe to mount in BTTApp root once.
 */
export const useKickerReveal = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.55, rootMargin: '0px 0px -10% 0px' }
    );

    const scan = () => {
      document.querySelectorAll('.btt-kicker:not(.is-visible)').forEach((el) => {
        if (reduceMotion) {
          el.classList.add('is-visible');
        } else {
          observer.observe(el);
        }
      });
    };

    scan();
    const interval = setInterval(scan, 600); // catch newly-mounted kickers on route changes

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);
};
